// Client-side EventBus implementation
import { EventBus } from '@gh/grub-foundation';

export const eventBus = new EventBus();
